import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    heading: {
        textAlign: 'center',
        maxWidth: 580,
        margin: '0 auto 24px',
    },
    list: {
        maxWidth: 760,
        margin: '0 auto',
        borderTop: '1px solid #e8e8ed',
    },
    accordion: {
        boxShadow: 'none',
        borderBottom: '1px solid #e8e8ed',
        '&:before': {
            display: 'none',
        },
        '&.Mui-expanded': {
            margin: 0,
        },
    },
    summary: {
        padding: '20px 4px',
    },
    question: {
        color: '#1a1a2f',
    },
    details: {
        padding: '0 4px 20px',
    },
    answer: {
        color: '#5a5a6a',
        lineHeight: 1.6,
    },
}));
